import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  ConversionRateState,
  CONVERSION_RATE_STATE,
} from './conversion-rate.state';

export const selectVelocityLimit = createFeatureSelector<ConversionRateState>(
  CONVERSION_RATE_STATE
);

export const selectConversionRate = createSelector(
  selectVelocityLimit,
  (state: ConversionRateState) => {
    return state.dataSource;
  }
);

export const selectConversionRateFilter = createSelector(
  selectVelocityLimit,
  (state: ConversionRateState) => state.filter
);
